module.exports = __webpack_public_path__ + "static/media/8-bit-pusab.0288f1e7.ttf";